import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/AddPart.css';
import useLocale from '../hooks/useLocale';

const AddPartButton = ({ onClick }) => {
  const locale = useLocale();
  return (
    <div className="add-part-button-container">
      <button type="button" className="add-part-button" onClick={onClick}>
        <FaPlus />{locale === 'ja' ? 'パートを追加' : 'New Part'}
      </button>
    </div>
  );
};

export default AddPartButton;
